import { b as _extends } from '../_rollupPluginBabelHelpers-6a814b33.js';
import React from 'react';
import 'prop-types';
import '../style-inject.es-a0e1a0ba.js';
import 'classnames';
import '../utils/qaAttributes.js';
import Icon from '../ui/Icon.js';

var CheckMarkIcon = (function (props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    symbol: /*#__PURE__*/React.createElement("svg", {
      viewBox: "-3 -4 16 16",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M3.933 5.519L8.232.359A1 1 0 0 1 9.768 1.64L4.776 7.63a1 1 0 0 1-1.492.068L.293 4.708a1 1 0 0 1 1.414-1.415l2.226 2.226z",
      fillRule: "nonzero"
    }))
  }, props));
});

export default CheckMarkIcon;
//# sourceMappingURL=CheckMark.js.map
